import React from "react";
import { Ong as ongE } from "../../../utils/entities/Ong";

const Description = (props: any) => {
  const ong: ongE = props.ong;

  return <div className="descripcion">{ong.description}</div>;
};

export default Description;
